<template>
  <div class="deal-card" v-if="deal">
    <router-link
      :to="{
        name: 'PrivateRaiseInfo',
        params: { id: deal.request || deal._id },
      }"
      class="deal-card__link"
    >
      <div class="deal-card__header">
        <span 
          v-if="deal.completed_raise !== true"
          class="deal-card__status"
          :class="[`deal-card__status--${deal.status.toLowerCase()}`]"
        >
          {{ deal.status }}
        </span>
        <svg v-if="deal.completed_raise === true" class="deal-card__check" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      
      <div class="deal-card__body">
        <img :src="deal.image" :alt="deal.name" class="deal-card__image" />
        <div class="deal-card__info">
          <h3 class="deal-card__name">{{ deal.name }}</h3>
          <p class="deal-card__raised">
            {{ formatAmountToDollar(totalRaised, 2, deal.currency || "USD") }} raised
          </p>
        </div>
      </div>
      
      <div class="deal-card__footer">
        <div class="deal-card__stat">
          <span class="deal-card__stat-label">Market Price</span>
          <span class="deal-card__stat-value">${{ deal.price.sell }}</span>
        </div>
        <div class="deal-card__stat deal-card__stat--right">
          <span class="deal-card__stat-label">Investment Type</span>
          <span class="deal-card__stat-value">{{ deal.investment_type }}</span>
        </div>
      </div>
      
      <div class="deal-card__action">
        <span class="deal-card__action-text">View Details</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </router-link>
  </div>
</template>
<script>
  import { convertToLocale, formatAmountToDollar } from "@/utils/helpers.js";
  export default {
    name: "Deal",
    props: {
      deal: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    computed: {
      totalRaised() {
        let totalRaised = null;
        if (this.deal.status === "Approved" && this.deal.token?.total_raised) {
          totalRaised = this.deal.token.total_raised *  this.deal.token?.price.exchange;
        } else {
          totalRaised = this.deal?.total_raised * this.deal?.price?.exchange;
        }
        return totalRaised;
      },
    },
    methods: {
      convertToLocale,
      formatAmountToDollar,
    },
  };
</script>
<style lang="scss" scoped>
.deal-card {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  &:hover {
    border-color: #CBD5E1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    
    .deal-card__action {
      color: #4D84FF;
      
      svg {
        transform: translateX(4px);
      }
    }
  }
  
  &__link {
    display: block;
    text-decoration: none;
  }
  
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 0;
  }
  
  &__status {
    display: inline-flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    
    &--approved {
      background: rgba(16, 185, 129, 0.1);
      color: #059669;
    }
    
    &--pending {
      background: rgba(245, 158, 11, 0.1);
      color: #D97706;
    }
    
    &--rejected {
      background: rgba(239, 68, 68, 0.1);
      color: #DC2626;
    }
    
    &--terminated {
      background: rgba(100, 116, 139, 0.1);
      color: #64748B;
    }
  }
  
  &__check {
    color: #10B981;
  }
  
  &__body {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 16px 20px;
  }
  
  &__image {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #E2E8F0;
  }
  
  &__info {
    flex: 1;
    min-width: 0;
  }
  
  &__name {
    font-size: 16px;
    font-weight: 500;
    color: #0F172A;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  &__raised {
    font-size: 14px;
    color: #64748B;
    font-weight: 400;
  }
  
  &__footer {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px;
    background: #F8FAFC;
    border-top: 1px solid #F1F5F9;
  }
  
  &__stat {
    &--right {
      text-align: right;
    }
    
    &-label {
      display: block;
      font-size: 12px;
      color: #64748B;
      margin-bottom: 4px;
      font-weight: 400;
    }
    
    &-value {
      font-size: 14px;
      font-weight: 500;
      color: #0F172A;
    }
  }
  
  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #E2E8F0;
    color: #64748B;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    svg {
      transition: transform 0.2s ease;
    }
  }
}
</style>
